var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupervoimaLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 468.35 657.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.51,645.21c-6.04,0-12.8-2.01-18.51-6.52l5.23-8.05c4.67,3.38,9.58,5.15,13.6,5.15,3.54,0,5.15-1.29,5.15-3.22v-.16c0-2.66-4.18-3.54-8.93-4.99-6.04-1.77-12.88-4.59-12.88-12.96v-.16c0-8.77,7.08-13.68,15.77-13.68,5.47,0,11.43,1.85,16.1,4.99l-4.67,8.45c-4.26-2.5-8.53-4.02-11.67-4.02s-4.51,1.29-4.51,2.98v.16c0,2.41,4.1,3.54,8.77,5.15,6.04,2.01,13.04,4.91,13.04,12.8v.16c0,9.58-7.16,13.92-16.5,13.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.74,644.4v-6.12c-2.82,3.62-6.44,6.92-12.64,6.92-9.26,0-14.65-6.12-14.65-16.02v-27.93h12.23v24.06c0,5.79,2.74,8.77,7.4,8.77s7.65-2.98,7.65-8.77v-24.06h12.23v43.14h-12.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.58,645.21c-6.52,0-10.54-2.98-13.44-6.44v18.51h-12.23v-56.01h12.23v6.2c2.98-4.02,7.08-7,13.44-7,10.06,0,19.64,7.89,19.64,22.29v.16c0,14.41-9.42,22.29-19.64,22.29ZM126.99,622.75c0-7.16-4.83-11.91-10.54-11.91s-10.46,4.75-10.46,11.91v.16c0,7.16,4.75,11.91,10.46,11.91s10.54-4.67,10.54-11.91v-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.31,627.1h-30.02c1.21,5.55,5.07,8.45,10.54,8.45,4.1,0,7.08-1.29,10.46-4.43l7,6.2c-4.02,4.99-9.82,8.05-17.62,8.05-12.96,0-22.53-9.09-22.53-22.29v-.16c0-12.31,8.77-22.45,21.33-22.45,14.41,0,21.01,11.19,21.01,23.42v.16c0,1.21-.08,1.93-.16,3.06ZM167.46,610.28c-5.07,0-8.37,3.62-9.34,9.17h18.43c-.72-5.47-3.94-9.17-9.09-9.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.91,613.26c-8.13,0-13.12,4.91-13.12,15.21v15.93h-12.23v-43.14h12.23v8.69c2.5-5.96,6.52-9.82,13.76-9.5v12.8h-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.42,644.72h-11.11l-16.98-43.46h12.96l9.66,28.89,9.74-28.89h12.72l-16.98,43.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.23,645.37c-13.36,0-23.26-9.9-23.26-22.29v-.16c0-12.39,9.98-22.45,23.42-22.45s23.26,9.9,23.26,22.29v.16c0,12.39-9.98,22.45-23.42,22.45ZM309.58,622.91c0-6.36-4.59-11.91-11.35-11.91s-11.19,5.39-11.19,11.75v.16c0,6.36,4.59,11.91,11.35,11.91s11.19-5.39,11.19-11.75v-.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 331.06,
    y: 601.26,
    width: 12.23,
    height: 43.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M408.39,644.4v-24.06c0-5.79-2.58-8.77-7.16-8.77s-7.41,2.98-7.41,8.77v24.06h-12.23v-24.06c0-5.79-2.58-8.77-7.16-8.77s-7.41,2.98-7.41,8.77v24.06h-12.23v-43.14h12.23v6.12c2.82-3.62,6.52-6.92,12.72-6.92,5.63,0,9.9,2.5,12.15,6.84,3.78-4.43,8.29-6.84,14.17-6.84,9.09,0,14.57,5.47,14.57,15.85v28.09h-12.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M456.52,644.4v-4.67c-2.98,3.3-7.08,5.47-13.04,5.47-8.13,0-14.81-4.67-14.81-13.2v-.16c0-9.42,7.16-13.76,17.38-13.76,4.35,0,7.48.72,10.54,1.77v-.72c0-5.07-3.14-7.89-9.26-7.89-4.67,0-7.97.89-11.91,2.33l-3.06-9.34c4.75-2.09,9.42-3.46,16.74-3.46,13.36,0,19.23,6.92,19.23,18.59v25.03h-11.83ZM456.76,627.02c-2.09-.97-4.83-1.61-7.81-1.61-5.23,0-8.45,2.09-8.45,5.95v.16c0,3.3,2.74,5.23,6.68,5.23,5.71,0,9.58-3.14,9.58-7.57v-2.17Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 18.3 180.49 18.3 196.91 18.3 196.91 0 179.04 0 179.04 18.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 18.3 202.51 18.3 218.92 18.3 218.92 0 201.06 0 201.06 18.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 18.3 224.53 18.3 240.94 18.3 240.94 0 223.08 0 223.08 18.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 18.3 246.54 18.3 262.96 18.3 262.96 0 245.09 0 245.09 18.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 18.3 268.56 18.3 284.97 18.3 284.97 0 267.11 0 267.11 18.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 18.3 290.58 18.3 306.99 18.3 306.99 0 289.12 0 289.12 18.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 40.75 114.44 40.75 130.86 40.75 130.86 22.45 112.99 22.45 112.99 40.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 40.75 136.46 40.75 152.87 40.75 152.87 22.45 135.01 22.45 135.01 40.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 40.75 158.48 40.75 174.89 40.75 174.89 22.45 157.03 22.45 157.03 40.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 40.75 180.49 40.75 196.91 40.75 196.91 22.45 179.04 22.45 179.04 40.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 40.75 202.51 40.75 218.92 40.75 218.92 22.45 201.06 22.45 201.06 40.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 40.75 224.53 40.75 240.94 40.75 240.94 22.45 223.08 22.45 223.08 40.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 40.75 246.54 40.75 262.96 40.75 262.96 22.45 245.09 22.45 245.09 40.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 40.75 268.56 40.75 284.97 40.75 284.97 22.45 267.11 22.45 267.11 40.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 40.75 290.58 40.75 306.99 40.75 306.99 22.45 289.12 22.45 289.12 40.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 40.75 312.59 40.75 329.01 40.75 329.01 22.45 311.14 22.45 311.14 40.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 40.75 334.61 40.75 351.02 40.75 351.02 22.45 333.16 22.45 333.16 40.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 40.75 356.62 40.75 373.04 40.75 373.04 22.45 355.17 22.45 355.17 40.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 63.19 70.41 63.19 86.83 63.19 86.83 44.9 68.96 44.9 68.96 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 63.19 92.43 63.19 108.84 63.19 108.84 44.9 90.98 44.9 90.98 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 63.19 114.44 63.19 130.86 63.19 130.86 44.9 112.99 44.9 112.99 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 63.19 136.46 63.19 152.87 63.19 152.87 44.9 135.01 44.9 135.01 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 63.19 158.48 63.19 174.89 63.19 174.89 44.9 157.03 44.9 157.03 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 63.19 180.49 63.19 196.91 63.19 196.91 44.9 179.04 44.9 179.04 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 63.19 202.51 63.19 218.92 63.19 218.92 44.9 201.06 44.9 201.06 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 63.19 224.53 63.19 240.94 63.19 240.94 44.9 223.08 44.9 223.08 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 63.19 246.54 63.19 262.96 63.19 262.96 44.9 245.09 44.9 245.09 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 63.19 268.56 63.19 284.97 63.19 284.97 44.9 267.11 44.9 267.11 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 63.19 290.58 63.19 306.99 63.19 306.99 44.9 289.12 44.9 289.12 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 63.19 312.59 63.19 329.01 63.19 329.01 44.9 311.14 44.9 311.14 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 63.19 334.61 63.19 351.02 63.19 351.02 44.9 333.16 44.9 333.16 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 63.19 356.62 63.19 373.04 63.19 373.04 44.9 355.17 44.9 355.17 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 63.19 378.64 63.19 395.05 63.19 395.05 44.9 377.19 44.9 377.19 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "399.21 63.19 400.66 63.19 417.07 63.19 417.07 44.9 399.21 44.9 399.21 63.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 85.64 70.41 85.64 86.83 85.64 86.83 67.35 68.96 67.35 68.96 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 85.64 92.43 85.64 108.84 85.64 108.84 67.35 90.98 67.35 90.98 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 85.64 114.44 85.64 130.86 85.64 130.86 67.35 112.99 67.35 112.99 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 85.64 136.46 85.64 152.87 85.64 152.87 67.35 135.01 67.35 135.01 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 85.64 158.48 85.64 174.89 85.64 174.89 67.35 157.03 67.35 157.03 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 85.64 180.49 85.64 196.91 85.64 196.91 67.35 179.04 67.35 179.04 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 85.64 202.51 85.64 218.92 85.64 218.92 67.35 201.06 67.35 201.06 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 85.64 224.53 85.64 240.94 85.64 240.94 67.35 223.08 67.35 223.08 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 85.64 246.54 85.64 262.96 85.64 262.96 67.35 245.09 67.35 245.09 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 85.64 268.56 85.64 284.97 85.64 284.97 67.35 267.11 67.35 267.11 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 85.64 290.58 85.64 306.99 85.64 306.99 67.35 289.12 67.35 289.12 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 85.64 312.59 85.64 329.01 85.64 329.01 67.35 311.14 67.35 311.14 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 85.64 334.61 85.64 351.02 85.64 351.02 67.35 333.16 67.35 333.16 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 85.64 356.62 85.64 373.04 85.64 373.04 67.35 355.17 67.35 355.17 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 85.64 378.64 85.64 395.05 85.64 395.05 67.35 377.19 67.35 377.19 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "399.21 85.64 400.66 85.64 417.07 85.64 417.07 67.35 399.21 67.35 399.21 85.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.94 108.09 48.39 108.09 64.81 108.09 64.81 89.79 46.94 89.79 46.94 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 108.09 70.41 108.09 86.83 108.09 86.83 89.79 68.96 89.79 68.96 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 108.09 92.43 108.09 108.84 108.09 108.84 89.79 90.98 89.79 90.98 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 108.09 114.44 108.09 130.86 108.09 130.86 89.79 112.99 89.79 112.99 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 108.09 136.46 108.09 152.87 108.09 152.87 89.79 135.01 89.79 135.01 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 108.09 158.48 108.09 174.89 108.09 174.89 89.79 157.03 89.79 157.03 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 108.09 180.49 108.09 196.91 108.09 196.91 89.79 179.04 89.79 179.04 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 108.09 202.51 108.09 218.92 108.09 218.92 89.79 201.06 89.79 201.06 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 108.09 224.53 108.09 240.94 108.09 240.94 89.79 223.08 89.79 223.08 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 108.09 246.54 108.09 262.96 108.09 262.96 89.79 245.09 89.79 245.09 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 108.09 268.56 108.09 284.97 108.09 284.97 89.79 267.11 89.79 267.11 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 108.09 290.58 108.09 306.99 108.09 306.99 89.79 289.12 89.79 289.12 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 108.09 312.59 108.09 329.01 108.09 329.01 89.79 311.14 89.79 311.14 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 108.09 334.61 108.09 351.02 108.09 351.02 89.79 333.16 89.79 333.16 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 108.09 356.62 108.09 373.04 108.09 373.04 89.79 355.17 89.79 355.17 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 108.09 378.64 108.09 395.05 108.09 395.05 89.79 377.19 89.79 377.19 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "399.21 108.09 400.66 108.09 417.07 108.09 417.07 89.79 399.21 89.79 399.21 108.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.94 130.54 48.39 130.54 64.81 130.54 64.81 112.24 46.94 112.24 46.94 130.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 130.54 70.41 130.54 86.83 130.54 86.83 112.24 68.96 112.24 68.96 130.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 130.54 92.43 130.54 108.84 130.54 108.84 112.24 90.98 112.24 90.98 130.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 130.54 114.44 130.54 130.86 130.54 130.86 112.24 112.99 112.24 112.99 130.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 130.54 136.46 130.54 152.87 130.54 152.87 112.24 135.01 112.24 135.01 130.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 130.54 158.48 130.54 174.89 130.54 174.89 112.24 157.03 112.24 157.03 130.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 130.54 180.49 130.54 196.91 130.54 196.91 112.24 179.04 112.24 179.04 130.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 130.54 268.56 130.54 284.97 130.54 284.97 112.24 267.11 112.24 267.11 130.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 130.54 290.58 130.54 306.99 130.54 306.99 112.24 289.12 112.24 289.12 130.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 130.54 312.59 130.54 329.01 130.54 329.01 112.24 311.14 112.24 311.14 130.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 130.54 334.61 130.54 351.02 130.54 351.02 112.24 333.16 112.24 333.16 130.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 130.54 356.62 130.54 373.04 130.54 373.04 112.24 355.17 112.24 355.17 130.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 130.54 378.64 130.54 395.05 130.54 395.05 112.24 377.19 112.24 377.19 130.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.93 152.99 26.38 152.99 42.79 152.99 42.79 134.69 24.93 134.69 24.93 152.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.94 152.99 48.39 152.99 64.81 152.99 64.81 134.69 46.94 134.69 46.94 152.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 152.99 70.41 152.99 86.83 152.99 86.83 134.69 68.96 134.69 68.96 152.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 152.99 92.43 152.99 108.84 152.99 108.84 134.69 90.98 134.69 90.98 152.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 152.99 114.44 152.99 130.86 152.99 130.86 134.69 112.99 134.69 112.99 152.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 152.99 136.46 152.99 152.87 152.99 152.87 134.69 135.01 134.69 135.01 152.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 152.99 158.48 152.99 174.89 152.99 174.89 134.69 157.03 134.69 157.03 152.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 152.99 334.61 152.99 351.02 152.99 351.02 134.69 333.16 134.69 333.16 152.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 152.99 356.62 152.99 373.04 152.99 373.04 134.69 355.17 134.69 355.17 152.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.93 175.44 26.38 175.44 42.79 175.44 42.79 157.14 24.93 157.14 24.93 175.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.94 175.44 48.39 175.44 64.81 175.44 64.81 157.14 46.94 157.14 46.94 175.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 175.44 70.41 175.44 86.83 175.44 86.83 157.14 68.96 157.14 68.96 175.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 175.44 92.43 175.44 108.84 175.44 108.84 157.14 90.98 157.14 90.98 175.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 175.44 114.44 175.44 130.86 175.44 130.86 157.14 112.99 157.14 112.99 175.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 175.44 136.46 175.44 152.87 175.44 152.87 157.14 135.01 157.14 135.01 175.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 175.44 158.48 175.44 174.89 175.44 174.89 157.14 157.03 157.14 157.03 175.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.93 197.89 26.38 197.89 42.79 197.89 42.79 179.59 24.93 179.59 24.93 197.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.94 197.89 48.39 197.89 64.81 197.89 64.81 179.59 46.94 179.59 46.94 197.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 197.89 70.41 197.89 86.83 197.89 86.83 179.59 68.96 179.59 68.96 197.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 197.89 92.43 197.89 108.84 197.89 108.84 179.59 90.98 179.59 90.98 197.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 197.89 114.44 197.89 130.86 197.89 130.86 179.59 112.99 179.59 112.99 197.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 197.89 136.46 197.89 152.87 197.89 152.87 179.59 135.01 179.59 135.01 197.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 197.89 158.48 197.89 174.89 197.89 174.89 179.59 157.03 179.59 157.03 197.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 197.89 180.49 197.89 196.91 197.89 196.91 179.59 179.04 179.59 179.04 197.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.93 220.33 26.38 220.33 42.79 220.33 42.79 202.04 24.93 202.04 24.93 220.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.94 220.33 48.39 220.33 64.81 220.33 64.81 202.04 46.94 202.04 46.94 220.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 220.33 70.41 220.33 86.83 220.33 86.83 202.04 68.96 202.04 68.96 220.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 220.33 92.43 220.33 108.84 220.33 108.84 202.04 90.98 202.04 90.98 220.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 220.33 114.44 220.33 130.86 220.33 130.86 202.04 112.99 202.04 112.99 220.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 220.33 136.46 220.33 152.87 220.33 152.87 202.04 135.01 202.04 135.01 220.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 220.33 158.48 220.33 174.89 220.33 174.89 202.04 157.03 202.04 157.03 220.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 220.33 180.49 220.33 196.91 220.33 196.91 202.04 179.04 202.04 179.04 220.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 220.33 202.51 220.33 218.92 220.33 218.92 202.04 201.06 202.04 201.06 220.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 220.33 224.53 220.33 240.94 220.33 240.94 202.04 223.08 202.04 223.08 220.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.94 242.78 48.39 242.78 64.81 242.78 64.81 224.49 46.94 224.49 46.94 242.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 242.78 70.41 242.78 86.83 242.78 86.83 224.49 68.96 224.49 68.96 242.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 242.78 92.43 242.78 108.84 242.78 108.84 224.49 90.98 224.49 90.98 242.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 242.78 114.44 242.78 130.86 242.78 130.86 224.49 112.99 224.49 112.99 242.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 242.78 136.46 242.78 152.87 242.78 152.87 224.49 135.01 224.49 135.01 242.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 242.78 158.48 242.78 174.89 242.78 174.89 224.49 157.03 224.49 157.03 242.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 242.78 180.49 242.78 196.91 242.78 196.91 224.49 179.04 224.49 179.04 242.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 242.78 202.51 242.78 218.92 242.78 218.92 224.49 201.06 224.49 201.06 242.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 242.78 224.53 242.78 240.94 242.78 240.94 224.49 223.08 224.49 223.08 242.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 242.78 246.54 242.78 262.96 242.78 262.96 224.49 245.09 224.49 245.09 242.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 242.78 268.56 242.78 284.97 242.78 284.97 224.49 267.11 224.49 267.11 242.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 242.78 290.58 242.78 306.99 242.78 306.99 224.49 289.12 224.49 289.12 242.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.94 265.23 48.39 265.23 64.81 265.23 64.81 246.93 46.94 246.93 46.94 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 265.23 70.41 265.23 86.83 265.23 86.83 246.93 68.96 246.93 68.96 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 265.23 92.43 265.23 108.84 265.23 108.84 246.93 90.98 246.93 90.98 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 265.23 114.44 265.23 130.86 265.23 130.86 246.93 112.99 246.93 112.99 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 265.23 136.46 265.23 152.87 265.23 152.87 246.93 135.01 246.93 135.01 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 265.23 158.48 265.23 174.89 265.23 174.89 246.93 157.03 246.93 157.03 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 265.23 180.49 265.23 196.91 265.23 196.91 246.93 179.04 246.93 179.04 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 265.23 202.51 265.23 218.92 265.23 218.92 246.93 201.06 246.93 201.06 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 265.23 224.53 265.23 240.94 265.23 240.94 246.93 223.08 246.93 223.08 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 265.23 246.54 265.23 262.96 265.23 262.96 246.93 245.09 246.93 245.09 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 265.23 268.56 265.23 284.97 265.23 284.97 246.93 267.11 246.93 267.11 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 265.23 290.58 265.23 306.99 265.23 306.99 246.93 289.12 246.93 289.12 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 265.23 312.59 265.23 329.01 265.23 329.01 246.93 311.14 246.93 311.14 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 265.23 334.61 265.23 351.02 265.23 351.02 246.93 333.16 246.93 333.16 265.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 287.68 70.41 287.68 86.83 287.68 86.83 269.38 68.96 269.38 68.96 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 287.68 92.43 287.68 108.84 287.68 108.84 269.38 90.98 269.38 90.98 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 287.68 114.44 287.68 130.86 287.68 130.86 269.38 112.99 269.38 112.99 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 287.68 136.46 287.68 152.87 287.68 152.87 269.38 135.01 269.38 135.01 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 287.68 158.48 287.68 174.89 287.68 174.89 269.38 157.03 269.38 157.03 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 287.68 180.49 287.68 196.91 287.68 196.91 269.38 179.04 269.38 179.04 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 287.68 202.51 287.68 218.92 287.68 218.92 269.38 201.06 269.38 201.06 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 287.68 224.53 287.68 240.94 287.68 240.94 269.38 223.08 269.38 223.08 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 287.68 246.54 287.68 262.96 287.68 262.96 269.38 245.09 269.38 245.09 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 287.68 268.56 287.68 284.97 287.68 284.97 269.38 267.11 269.38 267.11 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 287.68 290.58 287.68 306.99 287.68 306.99 269.38 289.12 269.38 289.12 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 287.68 312.59 287.68 329.01 287.68 329.01 269.38 311.14 269.38 311.14 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 287.68 334.61 287.68 351.02 287.68 351.02 269.38 333.16 269.38 333.16 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 287.68 356.62 287.68 373.04 287.68 373.04 269.38 355.17 269.38 355.17 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 287.68 378.64 287.68 395.05 287.68 395.05 269.38 377.19 269.38 377.19 287.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 310.13 114.44 310.13 130.86 310.13 130.86 291.83 112.99 291.83 112.99 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 310.13 136.46 310.13 152.87 310.13 152.87 291.83 135.01 291.83 135.01 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 310.13 158.48 310.13 174.89 310.13 174.89 291.83 157.03 291.83 157.03 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 310.13 180.49 310.13 196.91 310.13 196.91 291.83 179.04 291.83 179.04 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 310.13 202.51 310.13 218.92 310.13 218.92 291.83 201.06 291.83 201.06 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 310.13 224.53 310.13 240.94 310.13 240.94 291.83 223.08 291.83 223.08 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 310.13 246.54 310.13 262.96 310.13 262.96 291.83 245.09 291.83 245.09 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 310.13 268.56 310.13 284.97 310.13 284.97 291.83 267.11 291.83 267.11 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 310.13 290.58 310.13 306.99 310.13 306.99 291.83 289.12 291.83 289.12 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 310.13 312.59 310.13 329.01 310.13 329.01 291.83 311.14 291.83 311.14 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 310.13 334.61 310.13 351.02 310.13 351.02 291.83 333.16 291.83 333.16 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 310.13 356.62 310.13 373.04 310.13 373.04 291.83 355.17 291.83 355.17 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 310.13 378.64 310.13 395.05 310.13 395.05 291.83 377.19 291.83 377.19 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "399.21 310.13 400.66 310.13 417.07 310.13 417.07 291.83 399.21 291.83 399.21 310.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 332.58 158.48 332.58 174.89 332.58 174.89 314.28 157.03 314.28 157.03 332.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 332.58 180.49 332.58 196.91 332.58 196.91 314.28 179.04 314.28 179.04 332.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 332.58 202.51 332.58 218.92 332.58 218.92 314.28 201.06 314.28 201.06 332.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 332.58 224.53 332.58 240.94 332.58 240.94 314.28 223.08 314.28 223.08 332.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 332.58 246.54 332.58 262.96 332.58 262.96 314.28 245.09 314.28 245.09 332.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 332.58 268.56 332.58 284.97 332.58 284.97 314.28 267.11 314.28 267.11 332.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 332.58 290.58 332.58 306.99 332.58 306.99 314.28 289.12 314.28 289.12 332.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 332.58 312.59 332.58 329.01 332.58 329.01 314.28 311.14 314.28 311.14 332.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 332.58 334.61 332.58 351.02 332.58 351.02 314.28 333.16 314.28 333.16 332.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 332.58 356.62 332.58 373.04 332.58 373.04 314.28 355.17 314.28 355.17 332.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 332.58 378.64 332.58 395.05 332.58 395.05 314.28 377.19 314.28 377.19 332.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "399.21 332.58 400.66 332.58 417.07 332.58 417.07 314.28 399.21 314.28 399.21 332.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 355.03 224.53 355.03 240.94 355.03 240.94 336.73 223.08 336.73 223.08 355.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 355.03 246.54 355.03 262.96 355.03 262.96 336.73 245.09 336.73 245.09 355.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 355.03 268.56 355.03 284.97 355.03 284.97 336.73 267.11 336.73 267.11 355.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 355.03 290.58 355.03 306.99 355.03 306.99 336.73 289.12 336.73 289.12 355.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 355.03 312.59 355.03 329.01 355.03 329.01 336.73 311.14 336.73 311.14 355.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 355.03 334.61 355.03 351.02 355.03 351.02 336.73 333.16 336.73 333.16 355.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 355.03 356.62 355.03 373.04 355.03 373.04 336.73 355.17 336.73 355.17 355.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 355.03 378.64 355.03 395.05 355.03 395.05 336.73 377.19 336.73 377.19 355.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "399.21 355.03 400.66 355.03 417.07 355.03 417.07 336.73 399.21 336.73 399.21 355.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "421.22 355.03 422.67 355.03 439.09 355.03 439.09 336.73 421.22 336.73 421.22 355.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 377.47 290.58 377.47 306.99 377.47 306.99 359.18 289.12 359.18 289.12 377.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 377.47 312.59 377.47 329.01 377.47 329.01 359.18 311.14 359.18 311.14 377.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 377.47 334.61 377.47 351.02 377.47 351.02 359.18 333.16 359.18 333.16 377.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 377.47 356.62 377.47 373.04 377.47 373.04 359.18 355.17 359.18 355.17 377.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 377.47 378.64 377.47 395.05 377.47 395.05 359.18 377.19 359.18 377.19 377.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "399.21 377.47 400.66 377.47 417.07 377.47 417.07 359.18 399.21 359.18 399.21 377.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "421.22 377.47 422.67 377.47 439.09 377.47 439.09 359.18 421.22 359.18 421.22 377.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 399.92 70.41 399.92 86.83 399.92 86.83 381.63 68.96 381.63 68.96 399.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 399.92 312.59 399.92 329.01 399.92 329.01 381.63 311.14 381.63 311.14 399.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 399.92 334.61 399.92 351.02 399.92 351.02 381.63 333.16 381.63 333.16 399.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 399.92 356.62 399.92 373.04 399.92 373.04 381.63 355.17 381.63 355.17 399.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 399.92 378.64 399.92 395.05 399.92 395.05 381.63 377.19 381.63 377.19 399.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "399.21 399.92 400.66 399.92 417.07 399.92 417.07 381.63 399.21 381.63 399.21 399.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "421.22 399.92 422.67 399.92 439.09 399.92 439.09 381.63 421.22 381.63 421.22 399.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.94 422.37 48.39 422.37 64.81 422.37 64.81 404.07 46.94 404.07 46.94 422.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 422.37 70.41 422.37 86.83 422.37 86.83 404.07 68.96 404.07 68.96 422.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 422.37 92.43 422.37 108.84 422.37 108.84 404.07 90.98 404.07 90.98 422.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 422.37 114.44 422.37 130.86 422.37 130.86 404.07 112.99 404.07 112.99 422.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 422.37 312.59 422.37 329.01 422.37 329.01 404.07 311.14 404.07 311.14 422.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 422.37 334.61 422.37 351.02 422.37 351.02 404.07 333.16 404.07 333.16 422.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 422.37 356.62 422.37 373.04 422.37 373.04 404.07 355.17 404.07 355.17 422.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 422.37 378.64 422.37 395.05 422.37 395.05 404.07 377.19 404.07 377.19 422.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "399.21 422.37 400.66 422.37 417.07 422.37 417.07 404.07 399.21 404.07 399.21 422.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "421.22 422.37 422.67 422.37 439.09 422.37 439.09 404.07 421.22 404.07 421.22 422.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.93 444.82 26.38 444.82 42.79 444.82 42.79 426.52 24.93 426.52 24.93 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.94 444.82 48.39 444.82 64.81 444.82 64.81 426.52 46.94 426.52 46.94 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 444.82 70.41 444.82 86.83 444.82 86.83 426.52 68.96 426.52 68.96 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 444.82 92.43 444.82 108.84 444.82 108.84 426.52 90.98 426.52 90.98 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 444.82 114.44 444.82 130.86 444.82 130.86 426.52 112.99 426.52 112.99 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 444.82 136.46 444.82 152.87 444.82 152.87 426.52 135.01 426.52 135.01 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 444.82 158.48 444.82 174.89 444.82 174.89 426.52 157.03 426.52 157.03 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 444.82 180.49 444.82 196.91 444.82 196.91 426.52 179.04 426.52 179.04 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 444.82 268.56 444.82 284.97 444.82 284.97 426.52 267.11 426.52 267.11 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 444.82 290.58 444.82 306.99 444.82 306.99 426.52 289.12 426.52 289.12 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 444.82 312.59 444.82 329.01 444.82 329.01 426.52 311.14 426.52 311.14 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 444.82 334.61 444.82 351.02 444.82 351.02 426.52 333.16 426.52 333.16 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 444.82 356.62 444.82 373.04 444.82 373.04 426.52 355.17 426.52 355.17 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 444.82 378.64 444.82 395.05 444.82 395.05 426.52 377.19 426.52 377.19 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "399.21 444.82 400.66 444.82 417.07 444.82 417.07 426.52 399.21 426.52 399.21 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "421.22 444.82 422.67 444.82 439.09 444.82 439.09 426.52 421.22 426.52 421.22 444.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.93 467.27 26.38 467.27 42.79 467.27 42.79 448.97 24.93 448.97 24.93 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.94 467.27 48.39 467.27 64.81 467.27 64.81 448.97 46.94 448.97 46.94 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 467.27 70.41 467.27 86.83 467.27 86.83 448.97 68.96 448.97 68.96 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 467.27 92.43 467.27 108.84 467.27 108.84 448.97 90.98 448.97 90.98 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 467.27 114.44 467.27 130.86 467.27 130.86 448.97 112.99 448.97 112.99 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 467.27 136.46 467.27 152.87 467.27 152.87 448.97 135.01 448.97 135.01 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 467.27 158.48 467.27 174.89 467.27 174.89 448.97 157.03 448.97 157.03 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 467.27 180.49 467.27 196.91 467.27 196.91 448.97 179.04 448.97 179.04 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 467.27 202.51 467.27 218.92 467.27 218.92 448.97 201.06 448.97 201.06 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 467.27 224.53 467.27 240.94 467.27 240.94 448.97 223.08 448.97 223.08 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 467.27 246.54 467.27 262.96 467.27 262.96 448.97 245.09 448.97 245.09 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 467.27 268.56 467.27 284.97 467.27 284.97 448.97 267.11 448.97 267.11 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 467.27 290.58 467.27 306.99 467.27 306.99 448.97 289.12 448.97 289.12 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 467.27 312.59 467.27 329.01 467.27 329.01 448.97 311.14 448.97 311.14 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 467.27 334.61 467.27 351.02 467.27 351.02 448.97 333.16 448.97 333.16 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 467.27 356.62 467.27 373.04 467.27 373.04 448.97 355.17 448.97 355.17 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 467.27 378.64 467.27 395.05 467.27 395.05 448.97 377.19 448.97 377.19 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "399.21 467.27 400.66 467.27 417.07 467.27 417.07 448.97 399.21 448.97 399.21 467.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2.91 489.72 4.36 489.72 20.78 489.72 20.78 471.42 2.91 471.42 2.91 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.93 489.72 26.38 489.72 42.79 489.72 42.79 471.42 24.93 471.42 24.93 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.94 489.72 48.39 489.72 64.81 489.72 64.81 471.42 46.94 471.42 46.94 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 489.72 70.41 489.72 86.83 489.72 86.83 471.42 68.96 471.42 68.96 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 489.72 92.43 489.72 108.84 489.72 108.84 471.42 90.98 471.42 90.98 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 489.72 114.44 489.72 130.86 489.72 130.86 471.42 112.99 471.42 112.99 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 489.72 136.46 489.72 152.87 489.72 152.87 471.42 135.01 471.42 135.01 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 489.72 158.48 489.72 174.89 489.72 174.89 471.42 157.03 471.42 157.03 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 489.72 180.49 489.72 196.91 489.72 196.91 471.42 179.04 471.42 179.04 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 489.72 202.51 489.72 218.92 489.72 218.92 471.42 201.06 471.42 201.06 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 489.72 224.53 489.72 240.94 489.72 240.94 471.42 223.08 471.42 223.08 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 489.72 246.54 489.72 262.96 489.72 262.96 471.42 245.09 471.42 245.09 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 489.72 268.56 489.72 284.97 489.72 284.97 471.42 267.11 471.42 267.11 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 489.72 290.58 489.72 306.99 489.72 306.99 471.42 289.12 471.42 289.12 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 489.72 312.59 489.72 329.01 489.72 329.01 471.42 311.14 471.42 311.14 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 489.72 334.61 489.72 351.02 489.72 351.02 471.42 333.16 471.42 333.16 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 489.72 356.62 489.72 373.04 489.72 373.04 471.42 355.17 471.42 355.17 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 489.72 378.64 489.72 395.05 489.72 395.05 471.42 377.19 471.42 377.19 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "399.21 489.72 400.66 489.72 417.07 489.72 417.07 471.42 399.21 471.42 399.21 489.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.94 512.17 48.39 512.17 64.81 512.17 64.81 493.87 46.94 493.87 46.94 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.96 512.17 70.41 512.17 86.83 512.17 86.83 493.87 68.96 493.87 68.96 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 512.17 92.43 512.17 108.84 512.17 108.84 493.87 90.98 493.87 90.98 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 512.17 114.44 512.17 130.86 512.17 130.86 493.87 112.99 493.87 112.99 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 512.17 136.46 512.17 152.87 512.17 152.87 493.87 135.01 493.87 135.01 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 512.17 158.48 512.17 174.89 512.17 174.89 493.87 157.03 493.87 157.03 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 512.17 180.49 512.17 196.91 512.17 196.91 493.87 179.04 493.87 179.04 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 512.17 202.51 512.17 218.92 512.17 218.92 493.87 201.06 493.87 201.06 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 512.17 224.53 512.17 240.94 512.17 240.94 493.87 223.08 493.87 223.08 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 512.17 246.54 512.17 262.96 512.17 262.96 493.87 245.09 493.87 245.09 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 512.17 268.56 512.17 284.97 512.17 284.97 493.87 267.11 493.87 267.11 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 512.17 290.58 512.17 306.99 512.17 306.99 493.87 289.12 493.87 289.12 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 512.17 312.59 512.17 329.01 512.17 329.01 493.87 311.14 493.87 311.14 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 512.17 334.61 512.17 351.02 512.17 351.02 493.87 333.16 493.87 333.16 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 512.17 356.62 512.17 373.04 512.17 373.04 493.87 355.17 493.87 355.17 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "377.19 512.17 378.64 512.17 395.05 512.17 395.05 493.87 377.19 493.87 377.19 512.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.98 534.61 92.43 534.61 108.84 534.61 108.84 516.32 90.98 516.32 90.98 534.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.99 534.61 114.44 534.61 130.86 534.61 130.86 516.32 112.99 516.32 112.99 534.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "135.01 534.61 136.46 534.61 152.87 534.61 152.87 516.32 135.01 516.32 135.01 534.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 534.61 158.48 534.61 174.89 534.61 174.89 516.32 157.03 516.32 157.03 534.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 534.61 180.49 534.61 196.91 534.61 196.91 516.32 179.04 516.32 179.04 534.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 534.61 202.51 534.61 218.92 534.61 218.92 516.32 201.06 516.32 201.06 534.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 534.61 224.53 534.61 240.94 534.61 240.94 516.32 223.08 516.32 223.08 534.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 534.61 246.54 534.61 262.96 534.61 262.96 516.32 245.09 516.32 245.09 534.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 534.61 268.56 534.61 284.97 534.61 284.97 516.32 267.11 516.32 267.11 534.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 534.61 290.58 534.61 306.99 534.61 306.99 516.32 289.12 516.32 289.12 534.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.14 534.61 312.59 534.61 329.01 534.61 329.01 516.32 311.14 516.32 311.14 534.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.16 534.61 334.61 534.61 351.02 534.61 351.02 516.32 333.16 516.32 333.16 534.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.17 534.61 356.62 534.61 373.04 534.61 373.04 516.32 355.17 516.32 355.17 534.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "157.03 557.06 158.48 557.06 174.89 557.06 174.89 538.77 157.03 538.77 157.03 557.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.04 557.06 180.49 557.06 196.91 557.06 196.91 538.77 179.04 538.77 179.04 557.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.06 557.06 202.51 557.06 218.92 557.06 218.92 538.77 201.06 538.77 201.06 557.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.08 557.06 224.53 557.06 240.94 557.06 240.94 538.77 223.08 538.77 223.08 557.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.09 557.06 246.54 557.06 262.96 557.06 262.96 538.77 245.09 538.77 245.09 557.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.11 557.06 268.56 557.06 284.97 557.06 284.97 538.77 267.11 538.77 267.11 557.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.12 557.06 290.58 557.06 306.99 557.06 306.99 538.77 289.12 538.77 289.12 557.06"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervoimaLogoWhite);
export default __webpack_public_path__ + "static/media/Supervoima-Logo-White.d58422e1e848def7c6e471e0fcfadb52.svg";
export { ForwardRef as ReactComponent };